package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.CostFrequencyDto
import com.evoapps.evoshift.data.dto.workplace.RecurringCostRuleDto
import com.evoapps.evoshift.domain.model.CostFrequency
import com.evoapps.evoshift.domain.model.RecurringCostRule

class RecurringCostRuleMapper {

    fun toDomain(dto: RecurringCostRuleDto): RecurringCostRule {
        return RecurringCostRule(
            id = dto.uid,
            name = dto.name,
            amount = dto.amount,
            currency = dto.currency,
            frequency = when (dto.frequency) {
                CostFrequencyDto.MONTHLY -> CostFrequency.MONTHLY
                CostFrequencyDto.WEEKLY -> CostFrequency.WEEKLY
                CostFrequencyDto.YEARLY -> CostFrequency.YEARLY
                CostFrequencyDto.ONE_OFF -> CostFrequency.ONE_OFF
            },
            targetWorkplaceId = dto.targetWorkplaceId,
            kind = com.evoapps.evoshift.domain.model.LedgerKind.fromId(dto.kind)
        )
    }

    fun toDto(domain: RecurringCostRule): RecurringCostRuleDto {
        return RecurringCostRuleDto(
            uid = domain.id,
            name = domain.name,
            amount = domain.amount,
            currency = domain.currency,
            frequency = when (domain.frequency) {
                CostFrequency.MONTHLY -> CostFrequencyDto.MONTHLY
                CostFrequency.WEEKLY -> CostFrequencyDto.WEEKLY
                CostFrequency.YEARLY -> CostFrequencyDto.YEARLY
                CostFrequency.ONE_OFF -> CostFrequencyDto.ONE_OFF
            },
            targetWorkplaceId = domain.targetWorkplaceId,
            kind = domain.kind.name
        )
    }
}
